var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: "mdi-book-open-page-variant",
      show: _vm.dialog,
      maxWidth: "100%",
      showRequiredFields: false,
      showButton: false,
    },
    on: {
      onSave: _vm.saveAll,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _vm.loading
                          ? _c("v-progress-linear", {
                              attrs: {
                                indeterminate: "",
                                color: "cyan lighten-4",
                              },
                            })
                          : _vm._e(),
                        _vm.renderComponent
                          ? _c("v-data-table", {
                              staticClass: "elevation-1",
                              attrs: {
                                items: _vm.items,
                                headers: _vm.headers.filter((h) => h.visible),
                                "sort-by": "calories",
                                "item-key": "index",
                                "hide-default-footer": true,
                                "items-per-page": -1,
                                "fixed-header": "",
                                height: "400",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "top",
                                    fn: function () {
                                      return [
                                        _vm.showAddItem
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  color: "primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addItem()
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(" Adicionar Marcação "),
                                                _c("v-icon", [
                                                  _vm._v("mdi-plus"),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "item.date",
                                    fn: function ({ item, index }) {
                                      return [
                                        _c("emc-calendar-date-picker2", {
                                          attrs: {
                                            model: item.date,
                                            label: "",
                                            error: _vm.errors.length > 0,
                                            "error-messages":
                                              _vm.errors[
                                                "items." + index + ".date"
                                              ],
                                            show: _vm.dialog,
                                            min: _vm.dateMin,
                                            max: _vm.dateMax,
                                            "allowed-dates": _vm.allowedDates,
                                            dense: "",
                                            disabled:
                                              (item.id &&
                                                _vm.userType == "teacher") ||
                                              _vm.isItemBlocked(item)
                                                ? true
                                                : false,
                                          },
                                          on: {
                                            "update:model": function ($event) {
                                              return _vm.$set(
                                                item,
                                                "date",
                                                $event
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.hour",
                                    fn: function ({ item, index }) {
                                      return _vm._l(
                                        [_vm.periods[0], _vm.periods[1]],
                                        function (period, i) {
                                          return _c(
                                            "emc-calendar-time-picker",
                                            {
                                              key: i,
                                              attrs: {
                                                classText:
                                                  i === 0 ? "mt-4" : null,
                                                dense: "",
                                                error: !!_vm.errors[period],
                                                errors:
                                                  _vm.errors[
                                                    "items." +
                                                      index +
                                                      "." +
                                                      period
                                                  ],
                                                time: item[period],
                                                label:
                                                  i % 2 == 0 ? "Início" : "Fim",
                                                clearable: "",
                                                disabled:
                                                  (item.id &&
                                                    _vm.userType ==
                                                      "teacher") ||
                                                  _vm.isItemBlocked(item)
                                                    ? true
                                                    : false,
                                              },
                                              on: {
                                                "update:time": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    item,
                                                    period,
                                                    $event
                                                  )
                                                },
                                              },
                                            }
                                          )
                                        }
                                      )
                                    },
                                  },
                                  {
                                    key: "item.description",
                                    fn: function ({ item, index }) {
                                      return [
                                        _c("v-textarea", {
                                          staticClass: "mt-2",
                                          attrs: {
                                            error: _vm.errors.length > 0,
                                            "error-messages":
                                              _vm.errors[
                                                "items." +
                                                  index +
                                                  ".description"
                                              ],
                                            label: "",
                                            rows: "3",
                                            "auto-grow": "",
                                            outlined: "",
                                            disabled:
                                              (item.id &&
                                                _vm.userType == "teacher") ||
                                              _vm.isItemBlocked(item)
                                                ? true
                                                : false,
                                          },
                                          model: {
                                            value: item.description,
                                            callback: function ($$v) {
                                              _vm.$set(item, "description", $$v)
                                            },
                                            expression: "item.description",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.mark",
                                    fn: function ({ item, index }) {
                                      return _vm._l(
                                        [_vm.markings[0], _vm.markings[1]],
                                        function (mark, i) {
                                          return _c(
                                            "emc-calendar-time-picker",
                                            {
                                              key: i,
                                              attrs: {
                                                classText:
                                                  i === 0 ? "mt-4" : null,
                                                dense: "",
                                                error: !!_vm.errors[mark],
                                                errors:
                                                  _vm.errors[
                                                    "items." +
                                                      index +
                                                      "." +
                                                      mark
                                                  ],
                                                time: item[mark],
                                                label:
                                                  i % 2 == 0
                                                    ? "Entrada"
                                                    : "Saída",
                                                clearable: "",
                                                disabled:
                                                  _vm.isItemBlocked(item),
                                              },
                                              on: {
                                                "update:time": function (
                                                  $event
                                                ) {
                                                  return _vm.$set(
                                                    item,
                                                    mark,
                                                    $event
                                                  )
                                                },
                                              },
                                            }
                                          )
                                        }
                                      )
                                    },
                                  },
                                  {
                                    key: "item.type",
                                    fn: function ({ item }) {
                                      return [
                                        item.type
                                          ? _c(
                                              "span",
                                              [
                                                item.note || item.motive
                                                  ? _c("emc-info-help", {
                                                      attrs: {
                                                        title: "Justificativa",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "text",
                                                            fn: function () {
                                                              return [
                                                                item.motive
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item
                                                                            .motive
                                                                            .name
                                                                        )
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                item.note
                                                                  ? _c(
                                                                      "small",
                                                                      [
                                                                        _c(
                                                                          "br"
                                                                        ),
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.note
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  : _vm._e(),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(item.type.name) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.actions",
                                    fn: function ({ item, index }) {
                                      return [
                                        !_vm.hideEdit
                                          ? _c("emc-button-icon", {
                                              attrs: {
                                                loading:
                                                  index == _vm.indexItem &&
                                                  _vm.loadingUpdate,
                                                icon: "mdi-content-save-outline",
                                                color: "success",
                                                disabled:
                                                  _vm.disabledActions ||
                                                  _vm.isItemBlocked(item),
                                                text: "Salvar",
                                                iconSmall: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updateItem(
                                                    item,
                                                    index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        !_vm.hideDelete
                                          ? _c("emc-button-icon", {
                                              attrs: {
                                                loading:
                                                  index == _vm.indexItem &&
                                                  _vm.loadingDelete,
                                                icon:
                                                  _vm.userType == "user"
                                                    ? "mdi-delete"
                                                    : "mdi-calendar-minus",
                                                color: "primary",
                                                disabled:
                                                  _vm.disabledActions ||
                                                  item.occurrence_type_id !=
                                                    null,
                                                text:
                                                  _vm.userType == "user"
                                                    ? "Excluir"
                                                    : "Cadastrar Ocorrência",
                                                iconSmall: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showDeleteItem(
                                                    item,
                                                    index
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1207631471
                              ),
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-modal", {
              attrs: {
                title: "Justificativa de Alteração",
                icon: "mdi-text-box-edit-outline",
                text: "Informe o motivo da alteração nas marcações de ponto.",
                disabled: _vm.loadingUpdate,
                show: _vm.showJustificationModal,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showJustificationModal = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label:
                                    "Justificativa (Mínimo " +
                                    _vm.minNote +
                                    " caracteres)",
                                  counter: _vm.maxNote,
                                  rules: _vm.justificationRules,
                                  outlined: "",
                                  rows: "3",
                                  "auto-grow": "",
                                  placeholder:
                                    "Informe o motivo da alteração...",
                                },
                                model: {
                                  value: _vm.justificationNote,
                                  callback: function ($$v) {
                                    _vm.justificationNote = $$v
                                  },
                                  expression: "justificationNote",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "" },
                          on: {
                            click: function ($event) {
                              return _vm.cancelJustification()
                            },
                          },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.loadingUpdate,
                            disabled: !_vm.isJustificationValid,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.confirmJustification()
                            },
                          },
                        },
                        [
                          _vm._v(" Confirmar "),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v("mdi-check"),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("emc-alert-modal", {
              attrs: {
                title: "Ocorrências de Ponto",
                icon: "mdi-book-open-page-variant",
                text:
                  _vm.userType == "user"
                    ? "Confirma a exclusão do registros?"
                    : "Confirma o cadastro da ocorrência?",
                disabled: _vm.loadingDelete,
                show: _vm.showFormDeleteItem,
              },
              on: {
                "update:show": function ($event) {
                  _vm.showFormDeleteItem = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12" } },
                            [
                              _c("sys-select-occurrence-type", {
                                attrs: {
                                  model: _vm.occurrence_type_id,
                                  label: "Tipo de Ocorrência*",
                                  filterAdditional: "0",
                                  hideHolliday: "",
                                  hidePreMarked: "",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    _vm.occurrence_type_id = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "12" } },
                            [
                              _c("sys-select-occurrence-motive", {
                                attrs: {
                                  model:
                                    _vm.occurrence_sheet_register_motive_id,
                                  label: "Motivo*",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    _vm.occurrence_sheet_register_motive_id =
                                      $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        [
                          _vm.userType == "teacher"
                            ? _c("v-textarea", {
                                attrs: {
                                  label:
                                    "Justificativa (Mínimo " +
                                    _vm.minNote +
                                    "  caracteres)",
                                  counter: _vm.maxNote,
                                  rules: [
                                    (v) =>
                                      !v ||
                                      v.length <= _vm.maxNote ||
                                      "Máximo de 255 caracteres atingido",
                                  ],
                                  outlined: "",
                                  "aria-placeholder":
                                    "Informe uma justificativa com no mínimo" +
                                    _vm.minNote +
                                    "caracteres",
                                },
                                model: {
                                  value: _vm.note,
                                  callback: function ($$v) {
                                    _vm.note = $$v
                                  },
                                  expression: "note",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _vm.userType == "user"
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                loading: _vm.loadingDelete,
                                disabled: _vm.loadingDelete,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.deleteItem()
                                },
                              },
                            },
                            [
                              _vm._v("Excluir"),
                              _c("v-icon", { attrs: { right: "", dark: "" } }, [
                                _vm._v("mdi-delete"),
                              ]),
                            ],
                            1
                          )
                        : _vm.userType == "teacher"
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                loading: _vm.loadingDelete,
                                disabled: _vm.disabledSave,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  $event.stopPropagation()
                                  return _vm.absenceItem()
                                },
                              },
                            },
                            [
                              _vm._v("Cadastrar Ocorrência"),
                              _c("v-icon", { attrs: { right: "", dark: "" } }, [
                                _vm._v("mdi-calendar-minus"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }